<template lang="pug">
section.container-fluid.ensure_terms
  .container.container_shrink.i_ptb_6.d-none.d-md-block
    .row
      .col-12
        h2.i_h2_title.text-center.text-lg-left {{ itemTitle }}
    .row.justify-content-md-center.justify-content-lg-start
      item.i_mt_7(
        v-for="(item, index) in itemList",
        :key="index",
        :title="item.area02_ItemList_Title",
        :icon="item.area02_ItemList_icon"
      )
    .row.i_mt_14(v-if="otherItemList && otherItemList.length > 0")
      .col-12
        h2.i_h2_title.text-center.text-lg-left {{ otherItemTitle }}
    .row(v-if="otherItemList && otherItemList.length > 0")
      item.i_mt_7(
        v-for="(item, index) in otherItemList",
        :key="index",
        :title="item.area02_OtherItemList_Title",
        :icon="item.area02_OtherItemList_icon"
      )

  .container.i_ptb_6.d-md-none
    .row
      .col-12
        h2.i_h2_title.text-center.text-lg-left {{ itemTitle }}
    .row.i_mt_6
      .col-12.i_p_0
        swiper.swiper-container(:options="swiperOption", ref="mySwiper")
          swiper-slide.swiper-slide.d-flex.flex-column.align-items-center(
            v-for="(item, index) in itemList",
            :key="index"
          )
            item(
              :title="item.area02_ItemList_Title",
              :icon="item.area02_ItemList_icon"
            )
        svg-icon.swiper-prev.d-md-none(
          iconClass="arrow_left_mobile",
          className="icon",
          @click="prevClick"
        )

        svg-icon.swiper-next.d-md-none(
          iconClass="arrow_right_mobile",
          className="icon",
          @click="nextClick"
        )
    .row.i_mt_8(v-if="otherItemList && otherItemList.length > 0")
      .col-12
        h2.i_h2_title.text-center.text-lg-left {{ otherItemTitle }}
    .row.i_mt_6(v-if="otherItemList && otherItemList.length > 0")
      .col-12.i_p_0
        swiper.swiper-container(:options="swiperOption", ref="mySwiper")
          swiper-slide.swiper-slide.d-flex.flex-column.align-items-center(
            v-for="(item, index) in otherItemList",
            :key="index"
          )
            item(
              :title="item.area02_OtherItemList_Title",
              :icon="item.area02_OtherItemList_icon"
            )
        svg-icon.swiper-prev.d-md-none(
          iconClass="arrow_left_mobile",
          className="icon",
          @click="prevClick"
        )

        svg-icon.swiper-next.d-md-none(
          iconClass="arrow_right_mobile",
          className="icon",
          @click="nextClick"
        )
</template>

<script>
import Item from "@/components/product/Intro/EnsureTerms/Item";

export default {
  name: "EnsureTerms",
  components: {
    item: Item,
  },
  props: {
    itemTitle: String,
    itemList: Array,
    otherItemTitle: String,
    otherItemList: Array,
  },
  data() {
    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        slidesPerView: 3,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    prevClick() {
      this.swiper.slidePrev();
    },
    nextClick() {
      this.swiper.slideNext();
    },
    updateSliders() {
      if (document.body.clientWidth <= 767) {
        this.swiper.params.slidesPerView = 1;
      } else {
        this.swiper.params.slidesPerView = 3;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product/intro/ensure_terms";
</style>
